import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import { SidebarItem } from '@traton/devportal-env-kit-app';
import { useAgenticMarketplacePermissions } from '../../hooks/useAgenticMarketplacePermissions';

export const AgenticMarketplaceSidebarItem = () => {
  const { canRead, loading } = useAgenticMarketplacePermissions();

  if (loading || !canRead) return null;

  return (
    <SidebarItem
      icon={StorefrontOutlinedIcon}
      to="/agentic-marketplace"
      text="AI Marketplace"
      pluginId="agentic-marketplace"
      data-testid="agentic-marketplace-sidebar-button"
    />
  );
};
